import { render, staticRenderFns } from "./ManageAsList.vue?vue&type=template&id=03dfbd79&scoped=true&"
import script from "./ManageAsList.vue?vue&type=script&lang=js&"
export * from "./ManageAsList.vue?vue&type=script&lang=js&"
import style0 from "./ManageAsList.vue?vue&type=style&index=0&id=03dfbd79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dfbd79",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VDataTable})
